import { render, staticRenderFns } from "./mrc_ess_skeleton_loader.vue?vue&type=template&id=0eddd1a0&scoped=true&"
import script from "./mrc_ess_skeleton_loader.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_skeleton_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eddd1a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
